// Central business data for +5 Studio Training — Du Cunha
export const BIZ = {
  name: "+5 Studio Training",
  trainer: "Eduardo Cunha",
  nickname: "Du Cunha",
  cref: "CREF 063271-G/SP",
  yearsExp: 18,
  gradYear: 2007,
  phoneDisplay: "(11) 99728-4470",
  phoneRaw: "5511997284470",
  instagramHandle: "@ducunhapersonal_mais5studio",
  instagramUrl: "https://instagram.com/ducunhapersonal_mais5studio",
  address: {
    line1: "R. Antônio Latorre, 280",
    line2: "Vila das Hortências",
    city: "Jundiaí - SP",
    cep: "13209-400",
    full: "R. Antônio Latorre, 280, Vila das Hortências, Jundiaí - SP, 13209-400",
  },
  rating: { score: "5.0", count: 15 },
  hours: [
    { day: "Segunda a Sexta", time: "06:00 – 20:00" },
    { day: "Sábado", time: "08:00 – 11:00" },
    { day: "Domingo", time: "Fechado", closed: true },
  ],
};

const WA_TEXT = encodeURIComponent(
  "Olá, Du Cunha! Vim pelo site e gostaria de agendar minha avaliação física no +5 Studio Training."
);
export const WHATSAPP = `https://wa.me/${BIZ.phoneRaw}?text=${WA_TEXT}`;
export const PHONE_TEL = `tel:+${BIZ.phoneRaw}`;

export const MAP_EMBED =
  "https://www.google.com/maps?q=R.+Ant%C3%B4nio+Latorre,+280,+Vila+das+Hort%C3%AAncias,+Jundia%C3%AD+-+SP,+13209-400&output=embed";
export const MAP_LINK =
  "https://www.google.com/maps/search/?api=1&query=R.+Ant%C3%B4nio+Latorre,+280,+Vila+das+Hort%C3%AAncias,+Jundia%C3%AD+-+SP,+13209-400";

export const IMAGES = {
  logo: "/assets/logo.png",
  ducunha: "/assets/ducunha.png",
  studio: "/assets/studio.png",
  hero: "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  training:
    "https://images.unsplash.com/photo-1605296867724-fa87a8ef53fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  weights:
    "https://images.unsplash.com/photo-1685633225047-92be467dbe57?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const DIFFERENTIALS = [
  {
    tag: "01",
    title: "Studio Privativo",
    desc: "Um espaço reservado só para o seu treino. Sem filas, sem espera, sem plateia. Você e o seu objetivo — com total privacidade e foco.",
  },
  {
    tag: "02",
    title: "Dois Personais",
    desc: "Acompanhamento próximo com dois profissionais atentos a cada movimento, ajustando carga, postura e execução em tempo real.",
  },
  {
    tag: "03",
    title: "Treinos Personalizados",
    desc: "Musculação e aeróbico prescritos sob medida. Cada série é construída a partir do seu perfil, sua rotina e a sua meta.",
  },
  {
    tag: "04",
    title: "Ambiente Acolhedor",
    desc: "Estrutura de altíssimo padrão com uma atmosfera que te faz querer voltar. Treino sério, tratamento humano.",
  },
];

export const METHOD = [
  {
    n: "01",
    title: "Avaliação Real",
    desc: "Tudo começa entendendo você: histórico, dores, rotina e objetivo. Sem fórmula pronta.",
  },
  {
    n: "02",
    title: "Plano Sob Medida",
    desc: "Um programa de treinamento resistido desenhado para o seu corpo e o seu ritmo de vida.",
  },
  {
    n: "03",
    title: "Acompanhamento Contínuo",
    desc: "Ajustes constantes lado a lado. A cada evolução, o treino evolui junto com você.",
  },
];

export const TESTIMONIALS = [
  {
    text: "Em poucos meses os resultados apareceram de verdade. Ganhei massa magra e uma disposição que eu não sentia há anos.",
    tag: "Ganho de massa magra",
  },
  {
    text: "As dores articulares que me acompanhavam sumiram. Hoje treino com segurança e o acompanhamento faz toda a diferença.",
    tag: "Melhora de dores",
  },
  {
    text: "Estrutura de altíssimo padrão e atendimento realmente personalizado. Me sinto cuidado a cada sessão.",
    tag: "Estrutura premium",
  },
  {
    text: "Nunca me adaptei a academia lotada. O studio privativo mudou minha relação com o treino — resultado veio rápido.",
    tag: "Studio privativo",
  },
];
